import React from "react";
import ListBoxQueryMultiSelect from "./list_box_query";
import { listEmployeesFromOrganizationalUnit } from "../services/api_org_unit";
import { Link } from "wouter";
import { TrashIcon, UserPlusIcon, ArrowUturnLeftIcon } from '@heroicons/react/24/outline';



function OrgAddEmployeeRoleMembers({ unitData, token, isVisibleMembers, selectedEmployeesMembers, handleSelectionChangeMembers, toggleVisibilityMembers, handleUnselectEmployee, handleSaveMembers, handleRemoveEmployeeOU, isSaving }) {
    return (
        <div className='border border-solid-2 border-gray-200 shadow-md rounded-md my-5'>
            <div className='grid grid-cols-2 bg-gray-100 justify-between'>
                <div className='col-span-1'>
                    <h4 className='bg-gray-100 p-3 text-sm font-semibold uppercase'>Dipendenti dell'Unità Organizzativa</h4>
                </div>
            </div>
            {unitData.members?.length > 0 ? (
            <div className="max-h-[50vh] overflow-y-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead>
                        <tr>
                            <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider block sm:hidden sticky left-0 bg-white" style={{ width: '10%' }}></th>
                            <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider" style={{ width: '30%' }}>Codice Fiscale</th>
                            <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider" style={{ width: '30%' }}>Cognome</th>
                            <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider" style={{ width: '30%' }}>Nome</th>
                            <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider sm:block hidden" style={{ width: '10%' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {unitData.members
                            .slice()
                            .sort((a, b) => a.cf.localeCompare(b.cf))
                            .map((member, index) => (
                            <tr 
                                key={member.id} 
                                className={index !== unitData.members.length - 1 ? 'border-b border-gray-200' : ''}
                                style={member.has_active_contract ? { backgroundColor: 'white' } : PatternInactiveEmployee()}
                            >
                                <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700 block sm:hidden sticky left-0 bg-white" style={{ width: '10%' }}>
                                    <button className="text-gray-700 font-bold px-1 bg-white" title="Elimina">
                                        <TrashIcon className="h-6 w-6 hover:text-red-500"  onClick={() => handleRemoveEmployeeOU(member.id, 'members')} /> 
                                    </button>
                                </td>
                                <td className="px-3 py-2 text-sm text-left whitespace-nowrap text-gray-700 hover:underline-offset-2 hover:underline" style={{ width: '30%' }}>
                                <Link to={`/dipendenti/${member.cf}/`}>{member.cf}</Link>
                                </td>
                                <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700" style={{ width: '30%' }}>{member.last_name}</td>
                                <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700" style={{ width: '30%' }}>{member.first_name}</td>
                                <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700 sm:block hidden" style={{ width: '10%' }}>
                                    <button className="text-gray-700 font-bold px-1" title="Elimina">
                                        <TrashIcon className="h-6 w-6 hover:text-red-500"  onClick={() => handleRemoveEmployeeOU(member.id, 'members')} /> 
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        ) : (
            <p className="p-3 text-sm">Non sono presenti dipendenti</p>
        )}
            <div className='grid grid-cols-3 bg-gray-100 justify-between'>
                <div className='col-span-3 sm:col-span-1'> 
                    {isVisibleMembers && 
                        <div className='p-3'>
                            <ListBoxQueryMultiSelect
                                fetchData={async (query, page) => {
                                    const res = await listEmployeesFromOrganizationalUnit(token, unitData?.id, query, 'member', page);
                                    const array = Array.isArray(res.data) ? res.data : [];
                                    return array.map(dip => ({
                                    name: dip.last_name && dip.first_name ? `${dip.last_name} ${dip.first_name}` : dip.cf,
                                    value: dip.id,
                                    original: dip
                                    }));
                                }}
                                selectedValues={selectedEmployeesMembers.map(dip => ({
                                    name: dip.last_name && dip.first_name ? `${dip.last_name} ${dip.first_name}` : dip.cf,
                                    value: dip.id,
                                    original: dip
                                }))}
                                openDirection='down'
                                onChange={handleSelectionChangeMembers}
                                placeholder="Cerca dipendente..."
                            />
                        </div>
                    }
                </div>

                {isVisibleMembers && selectedEmployeesMembers.length > 0 ? (
                    <div className='col-span-3 sm:col-span-1 flex items-center justify-end pe-5 py-3'>
                        <button 
                            className={`flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md w-60 hover:bg-white rounded-md ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`} 
                            title="Salva" 
                            onClick={() => handleSaveMembers(selectedEmployeesMembers)}
                            disabled={isSaving}
                        >
                            {isSaving ? <p className='p-2 text-sm uppercase'>Salvataggio...</p> : <p className='p-2 text-sm uppercase'>Conferma e Salva</p>}
                            <UserPlusIcon className="h-6 w-6 text-indigo-800" />
                        </button>
                    </div>
                ) : (
                    <div className='col-span-1'></div>
                )}
                <div className='col-span-3 sm:col-span-1 flex items-center justify-end pe-5 py-3'>
                    {!isVisibleMembers ? (
                        <button 
                            className="flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md w-60 hover:bg-white rounded-md" 
                            title="Aggiungi" 
                            onClick={toggleVisibilityMembers}
                        >
                            <p className='p-2 text-sm uppercase'>Aggiungi dipendenti</p>
                            <UserPlusIcon className="h-6 w-6 text-indigo-800" />
                        </button>
                    ) : (
                        <button 
                            className="flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md w-60 hover:bg-white rounded-md sm:ml-0 ml-3" 
                            title="Annulla" 
                            onClick={toggleVisibilityMembers}
                        >
                            <p className='p-2 text-sm uppercase'>Annulla</p>
                            <ArrowUturnLeftIcon className="h-6 w-6 text-indigo-800" />
                        </button>
                    )}
                </div>

                {isVisibleMembers && selectedEmployeesMembers.length > 0 && (
                    <>
                        <div className='col-span-3 p-4 max-h-[50vh] overflow-y-auto'>
                            <table className="min-w-full divide-y divide-gray-200 bg-white">
                                <thead>
                                    <tr>
                                        <th colSpan={4} className="p-3 text-center text-sm border-b border-gray-200 font-semibold text-gray-800 uppercase tracking-wider bg-gray-50">Aggiungi Dipendenti</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={1} className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50 sticky left-0" style={{ width: '10%' }}></th>
                                        <th colSpan={1} className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50" style={{ width: '30%' }}>Codice Fiscale</th>
                                        <th colSpan={1} className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50" style={{ width: '30%' }}>Cognome</th>
                                        <th colSpan={1} className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50" style={{ width: '30%' }}>Nome</th>
                                        <th colSpan={1} className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50 hidden sm:block" style={{ width: '10%' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedEmployeesMembers.map((employee, index) => (
                                        <React.Fragment key={employee.id}>
                                            <tr>
                                                <td className="px-3 py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white block sm:hidden sticky left-0" style={{ width: '10%' }}>
                                                    <button className="text-gray-700 font-bold px-1 bg-white" title="Elimina" onClick={() => handleUnselectEmployee(employee.id, 'members')}>
                                                        <TrashIcon className="h-6 w-6 hover:text-red-500" /> 
                                                    </button>
                                                </td>
                                                <td className="px-3 py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white" style={{ width: '30%' }}>{employee.cf}</td>
                                                <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white" style={{ width: '30%' }}>{employee.last_name}</td>
                                                <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white" style={{ width: '30%' }}>{employee.first_name}</td>
                                                <td className="px-3 py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white hidden sm:block" style={{ width: '10%' }}>
                                                    <button className="text-gray-700 font-bold px-1" title="Elimina" onClick={() => handleUnselectEmployee(employee.id, 'members')}>
                                                        <TrashIcon className="h-6 w-6 hover:text-red-500" /> 
                                                    </button>
                                                </td>
                                            </tr>
                                            {index !== selectedEmployeesMembers.length - 1 && <tr><td colSpan={4} className="border-t border-gray-100"></td></tr>}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
};

export default OrgAddEmployeeRoleMembers;

const PatternInactiveEmployee = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23a5b4fc' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};
